import { render, staticRenderFns } from "./LockButton.vue?vue&type=template&id=667666b0&"
import script from "./LockButton.vue?vue&type=script&lang=js&"
export * from "./LockButton.vue?vue&type=script&lang=js&"
import style0 from "./LockButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports